(() => {
  document.addEventListener('DOMContentLoaded', () => {
    const section = document.querySelector('.featured-makers');
    if (!section) return;

    const filters = [...section.querySelectorAll('.featured-makers__filter')];
    const cards = [...section.querySelectorAll('.featured-makers__card')];
    const pagination = section.querySelector('.featured-makers__pagination');
    const grid = section.querySelector('.featured-makers__grid');

    const pageSize = 24;

    let filteredCards = [...cards];
    let currentPage = 1;

    function scrollToGrid() {
      grid.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }

    function renderPage() {
      cards.forEach(card => card.classList.add('is-hidden'));

      const start = (currentPage - 1) * pageSize;
      const end = start + pageSize;

      filteredCards.slice(start, end).forEach(card => {
        card.classList.remove('is-hidden');
      });

      renderPagination();
    }

    function renderPagination() {
      if (!pagination) return;

      pagination.innerHTML = '';

      const totalPages = Math.ceil(filteredCards.length / pageSize);

      if (totalPages <= 1) return;

      // Previous
      const prev = document.createElement('button');
      prev.textContent = '← Previous';
      prev.className = 'featured-makers__page-nav';
      prev.disabled = currentPage === 1;

      prev.addEventListener('click', () => {
        if (currentPage === 1) return;

        currentPage--;
        renderPage();
        scrollToGrid();
      });

      pagination.appendChild(prev);

      // Page numbers
      for (let i = 1; i <= totalPages; i++) {
        const btn = document.createElement('button');

        btn.textContent = i;
        btn.className = 'featured-makers__page-btn';

        if (i === currentPage) {
          btn.classList.add('is-active');
        }

        btn.addEventListener('click', () => {
          if (i === currentPage) return;

          currentPage = i;
          renderPage();
          scrollToGrid();
        });

        pagination.appendChild(btn);
      }

      // Next
      const next = document.createElement('button');
      next.textContent = 'Next →';
      next.className = 'featured-makers__page-nav';
      next.disabled = currentPage === totalPages;

      next.addEventListener('click', () => {
        if (currentPage === totalPages) return;

        currentPage++;
        renderPage();
        scrollToGrid();
      });

      pagination.appendChild(next);
    }

    filters.forEach(filter => {
      filter.addEventListener('click', () => {
        const selectedFilter = filter.dataset.filter;

        filters.forEach(button =>
          button.classList.toggle('is-active', button === filter)
        );

        filteredCards = cards.filter(card => {
          const tagList = (card.dataset.impactTags || '')
            .trim()
            .split(/\s+/)
            .filter(Boolean);

          return (
            selectedFilter === 'all' ||
            tagList.includes(selectedFilter)
          );
        });

        currentPage = 1;
        renderPage();
      });
    });

    renderPage();
  });
})();